// IntegrationSync.page.tsx
// ★ 통합 마이그레이션 sync 라우트 (/integration/sync) — receiver 가 띄운 iframe target.
//   실제 응답 로직은 index.html 의 inline script (HTML parse 시점에 listener 등록 → race-safe).
// 이 라우트는 이후 React Router가 뜰 때 iframe 안에서 catch-all/redirect가 도는 것을 막는 placeholder
const IntegrationSync = () => null

export default IntegrationSync
